<template>
  <div>
    <v-card>
      <v-tabs v-model="terms" centered icons-and-text>
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#term1">Term 1</v-tab>
        <v-tab href="#term2">Term 2</v-tab>
        <v-tab href="#term3">Term 3</v-tab>
        <v-tab href="#term4">Term 4</v-tab>
      </v-tabs>

      <v-tabs-items v-model="terms">
        <v-tab-item value="term1">
          <div
            v-if="typeof getCurrentStudentProfile.term1 == 'object' && getCurrentStudentProfile.term1.dsc != undefined"
          >
            <div v-if="getCurrentStudentProfile.term1.blocked">
              <v-row>
                <v-alert class="mx-auto my-6 h4 py-6 warning text-center" color="warning" dark>
                  Report Blocked!
                  <br />
                  <br />
                  Reason: {{getCurrentStudentProfile.term1.reason}}
                </v-alert>
              </v-row>
            </div>
            <div v-else>
              <ReportCardComponent :term="getCurrentStudentProfile.term1" :termData="term1Subs"></ReportCardComponent>
            </div>
          </div>
          <v-row v-else>
            <div flat class="mx-auto my-4">
              <v-card-title>No Data Found For Term 1</v-card-title>
            </div>
          </v-row>
        </v-tab-item>
        <v-tab-item value="term2">
          <div
            v-if="typeof getCurrentStudentProfile.term2 == 'object' && getCurrentStudentProfile.term2.dsc != undefined"
          >
            <div v-if="getCurrentStudentProfile.term2.blocked">
              <v-row>
                <v-alert class="mx-auto my-6 h4 py-6 warning text-center" color="warning" dark>
                  Report Blocked!
                  <br />
                  <br />
                  Reason: {{getCurrentStudentProfile.term2.reason}}
                </v-alert>
              </v-row>
            </div>
            <div v-else>
              <ReportCardComponent :term="getCurrentStudentProfile.term2" :termData="term2Subs"></ReportCardComponent>
            </div>
          </div>
          <v-row v-else>
            <div flat class="mx-auto my-4">
              <v-card-title>No Data Found For Term 2</v-card-title>
            </div>
          </v-row>
        </v-tab-item>
        <v-tab-item value="term3">
          <div
            v-if="typeof getCurrentStudentProfile.term3 == 'object' && getCurrentStudentProfile.term3.dsc != undefined"
          >
            <div v-if="getCurrentStudentProfile.term3.blocked">
              <v-row>
                <v-alert class="mx-auto my-6 h4 py-6 warning text-center" color="warning" dark>
                  Report Blocked!
                  <br />
                  <br />
                  Reason: {{getCurrentStudentProfile.term3.reason}}
                </v-alert>
              </v-row>
            </div>
            <div v-else>
              <ReportCardComponent :term="getCurrentStudentProfile.term3" :termData="term3Subs"></ReportCardComponent>
            </div>
          </div>
          <v-row v-else>
            <div flat class="mx-auto my-4">
              <v-card-title>No Data Found For Term 3</v-card-title>
            </div>
          </v-row>
        </v-tab-item>
        <v-tab-item value="term4">
          <div
            v-if="typeof getCurrentStudentProfile.term4 == 'object' && getCurrentStudentProfile.term4.dsc != undefined"
          >
            <div v-if="getCurrentStudentProfile.term4.blocked">
              <v-row>
                <v-alert class="mx-auto my-6 h4 py-6 warning text-center" color="warning" dark>
                  Report Blocked!
                  <br />
                  <br />
                  Reason: {{getCurrentStudentProfile.term4.reason}}
                </v-alert>
              </v-row>
            </div>
            <div v-else>
              <ReportCardComponent :term="getCurrentStudentProfile.term4" :termData="term4Subs"></ReportCardComponent>
            </div>
          </div>
          <v-row v-else>
            <div flat class="mx-auto my-4">
              <v-card-title>No Data Found For Term 4</v-card-title>
            </div>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import ReportCardComponent from "@/components/SchoolAdmin/ReportCardComponent.vue";
export default {
  components: { ReportCardComponent },
  computed: {
    getCurrentStudentProfile() {
      return this.$store.getters.getCurrentStudentProfile;
    }
  },
  mounted() {
    this.term1Subs = this.getSubjectsAndScores(
      this.getCurrentStudentProfile.term1
    );
    this.term2Subs = this.getSubjectsAndScores(
      this.getCurrentStudentProfile.term2
    );
    this.term3Subs = this.getSubjectsAndScores(
      this.getCurrentStudentProfile.term3
    );
    this.term4Subs = this.getSubjectsAndScores(
      this.getCurrentStudentProfile.term4
    );
  },

  data: () => ({
    terms: null,
    term1Subs: [],
    term2Subs: [],
    term3Subs: [],
    term4Subs: [],
    gradients: [
      ["#222"],
      ["#42b3f4"],
      ["red", "orange", "yellow"],
      ["purple", "violet"],
      ["#00c6ff", "#F0F", "#FF0"],
      ["#f72047", "#ffd200", "#1feaea"]
    ]
  }),
  methods: {
    getSubjectsAndScores(term) {
      const subPairs = Object.entries(term);
      return subPairs;
    }
  }
};
</script>

<style>
</style>